import React from 'react'
import { Text, TouchableOpacity } from 'react-native'

/** The "?" glyph size for a help circle of `size` px. */
export const helpGlyphSize = (size: number) => Math.round(size * 0.45)

export function HelpButton({ onPress, accessibilityLabel, testID, size = 34 }: {
  onPress: () => void
  accessibilityLabel: string
  testID?: string
  size?: number
}) {
  return <TouchableOpacity
    testID={testID}
    onPress={onPress}
    accessibilityLabel={accessibilityLabel}
    accessibilityRole="button"
    activeOpacity={0.75}
    hitSlop={6}
    className="bg-paper border-2 border-olive rounded-full items-center justify-center"
    style={{ width: size, height: size, flexShrink: 0 }}
  >
    {/* Scales with the circle (was a fixed 18px, crowding the small ones). */}
    <Text className="font-stencil text-ink" style={{ fontSize: helpGlyphSize(size), lineHeight: helpGlyphSize(size) + 2 }}>?</Text>
  </TouchableOpacity>
}
